<template>
  <div id="guide">
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="ご購入方法" />
    <div class="guide-body">
      <introduction />
      <purchase-flow />
      <about-payment />
      <how-to-shipping />
      <div class="content">
        <content-header title="送料・代引き手数料について" />
        <div class="content-body">国内に限り、弊社で負担いたします。</div>
      </div>
      <about-cancel />
      <div class="content">
        <content-header title="お問い合わせ窓口" />
        <div class="content-body">
          お電話または
          <router-link to="/contact" style="font-weight: bold;">
            お問い合わせフォーム
          </router-link>
          からご連絡ください。
          <router-link to="/contact" style="font-weight: bold;">
            【お問い合わせフォーム】
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import ContentHeader from '@/components/modules/ContentHeader'
import Introduction from '@/components/modules/guide/Introduction'
import PurchaseFlow from '@/components/modules/guide/PurchaseFlow'
import AboutPayment from '@/components/modules/guide/AboutPayment'
import HowToShipping from '@/components/modules/guide/HowToShipping'
import AboutCancel from '@/components/modules/guide/AboutCancel'
import Breadcrumb from '@/components/modules/Breadcrumb'

export default {
  components: {
    HeaderBanner,
    ContentHeader,
    Introduction,
    PurchaseFlow,
    AboutPayment,
    HowToShipping,
    AboutCancel,
    Breadcrumb,
  },
  title: 'ご購入方法｜B-Call（ビーコール）',
  meta:
    '商品についてのご質問は、ビーコールまでお気軽にご相談･お問い合わせください。呼び出しチャイム、パーソナルコールシステム専門店B-Callの担当スタッフが、ご予算やご希望に合ったアドバイスをいたします。',
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: 'ご購入方法',
            path: 'https://b-call.jp/guide',
          },
        ],
      }
    },
  },
}
</script>

<style>
.guide-body {
  width: 90%;
  max-width: 1100px;
  margin: 0 auto;
}

.guide-body a {
  display: inline-block;

  text-decoration: none;

  color: #4d4d4d;
}

.content {
  margin-bottom: 30px;
}

.content-body {
  font-size: 14px;

  margin: 15px 0 15px 0;
}

.content-circle {
  margin: 10px 0;
  padding: 15px 25px;

  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #eee;
}

.content-label {
  font-weight: bold;

  width: 100px;
  margin: 15px 0;
  padding: 5px 20px;

  text-align: center;

  color: white;
  border-radius: 20px;
  background-color: rgb(80, 172, 252);
}

.content-subtitle {
  font-weight: bold;
  color: rgb(9, 81, 141);
}

.subtitle-red {
  color: red;
}

.subtitle-skyblue {
  color: rgb(26, 161, 230);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Guide.vue